import { i18n } from "@lingui/core"

import { messages as ar } from "./locales/ar/messages"
import { messages as en } from "./locales/en/messages"
import { messages as fr } from "./locales/fr/messages"
import { messages as es } from "./locales/es/messages"
import { messages as sw } from "./locales/sw/messages"
import { messages as pt } from "./locales/pt/messages"
import { messages as lb } from "./locales/lb/messages"
// import { messages as ha } from "./locales/ha/messages"
// import { messages as zarma } from "./locales/zarma/messages"

export const locales = {
  ar: "Arabic",
  en: "English", // deafult locale
  fr: "French",
  es: "Spanish",
  sw: "Swahili",
  pt: "Portuguese",
  // zarma: "Zarma",
  // ha: "Haoussa",
  lb: "Lebanese",
}
export const defaultLocale = "en"

const catalogs = {
  en,
  pt,
  ar,
  fr,
  es,
  lb,
  sw
}
/**
 * We do a dynamic import of just the catalog that we need
 * @param locale any locale string
 */
export function dynamiclyActivate(locale) {
  const assertedLocale = locale in locales ? locale : defaultLocale
  const messages = catalogs[assertedLocale]
  i18n.loadAndActivate({ locale: assertedLocale, messages })
}
